<template>
  <collapsible-section class='_pt0 _pb0' :collapsible="false" >
    <template #headerText>
      <p class='color-leaf'></p>
    </template>
    <template #headerActions>
    </template>
    <template #collapsibleSection>
      <div container>
        <div id="benefit-display-app">
          <script type="application/javascript"  src="/theme/vue/benefitdisplay/output/benefitDisplay.js"></script>
        </div>
      </div>
    </template>
  </collapsible-section>
  <!--div id="benefit-display-app">
      <script type="application/javascript"  src="http://localhost:7010/theme/vue/benefitdisplay/output/benefitDisplay-dev.js"></script>
  </div-->
</template>

<script>

  import { formatDate } from '@/utils'
  import CollapsibleSection from '@sections/CollapsibleSection'

  export default {
    props: {
      groupCk: String,
      groupName: String,
      groupId: String,
      subGroupId: String,
      subGroupName: String,
      classId: String,
      planId: String,
      productId: String,
      token: String
    },
    components: {
      CollapsibleSection
    },
    mounted() {
      var numTry = 0
      const self = this
      var interval = setInterval(function() {
        if (typeof window.bdEventBus === 'undefined' && typeof bdEventBus === 'undefined') {
          numTry++
          if (numTry < 10) {
            console.log('bdEventBus not detected')
          } else {
            clearInterval(interval)
          }
        } else {
          window.bdEventBus.groupCk = self.groupCk
          window.bdEventBus.groupId = self.groupId
          window.bdEventBus.groupName = self.groupName
          window.bdEventBus.subGroupId = self.subGroupId
          window.bdEventBus.subGroupName = self.subGroupName
          window.bdEventBus.classId = self.classId
          window.bdEventBus.classPlanId = self.planId
          window.bdEventBus.dateOfService = formatDate(self.$route.query.serviceDate)
          window.bdEventBus.moduleId = '300'
          window.bdEventBus.token = self.token
          window.bdEventBus.memberCk = ''
          window.bdEventBus.refreshBenefits()
          clearInterval(interval)
        }
      }, 500)

      // this.updateCustomAppContainer();
    },
    methods: {
      updateCustomAppContainer() {
        window.bdEventBus.refreshBenefits()
        // document.getElementById(
        // "customAppContainer"
        // ).innerHTML = `<object style="width: 100%; height:100%;" data="http://localhost:7010/theme/vue/benefitdisplay/dist/index.html"><param name="benefitConfig" value="{memberId: '1234'}"></object>`;
      }
    }
    /* beforeRouteLeave (to, from, next) {
      window.location.reload(true);
      next();
    } */
    /* watch: {
      $route(to, from) {
        this.$router.push(to);
        window.location.reload(true);
      }
    } */

  }
</script>
<style>
   @import '../../assets/benefitDisplay.css';
</style>
